import { environment } from './../../../../environments/environment.portal.fortwayne311.prod';
import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {FormGroup,FormControl,Validators,FormArray,FormBuilder} from '@angular/forms';
//import { CKEditor4, } from 'ckeditor4-angular';
import { StandardUIService } from '../../../services/standardui-service/standardui-service';
import { EmailNoteService } from '../../../services/emailnote/emailnote-services';
import { MatDialog } from '@angular/material/dialog';
import { KnowledgebaseComponent } from 'src/app/NewServiceRequest/knowledgebase/knowledgebase.component';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
// import {environment} from "../../../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { FileuploadService } from 'src/app/services/FileUpload/fileupload.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';



declare var $: any;
@Component({
  selector: 'app-incident-message-details',
  templateUrl: './incident-message-details.component.html',
  styleUrls: ['./incident-message-details.component.scss']
})
export class IncidentMessageDetailsComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  @Input() type:string;
  @Input() modalRef: NgbModalRef;
  @Input() entityData;
  @Input() emailNotesData;
  fileToUpload: File;
  imgUrl: any=[];
  constructor(
    private emailNoteService: EmailNoteService,
    private fileUploadService: FileuploadService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public standardUIService: StandardUIService,
    public dialog: MatDialog,
    public kbs: ApiserviceService,
    private cdr: ChangeDetectorRef
  ) { }
  EmailForm:FormGroup;
  //ckeConfig: CKEditor4.Config;
  incidentW:any;
  public editorOptions: Object;
  public items = [];
  public disableSendButton:boolean = true;

  private attachmentUploadsInProgress = 0;
  private lastFileTransferSignature = '';
  private lastFileTransferAt = 0;
  private readonly maxAttachmentSize = 10 * 1024 * 1024;

  private activeFroalaEditor: any;

  get emailFormData() { return this.EmailForm.controls; }
  private refreshAttachmentView(): void {
    this.cdr.detectChanges();
  }
  private normalizeUrl(url: string): string {
    if (!url) {
      return '';
    }
    try {
      const normalized = new URL(url, window.location.origin).href;
      try {
        return decodeURIComponent(normalized);
      } catch {
        return normalized;
      }
    } catch {
      return url;
    }
  }
  private extractUrlsFromHtml(html: string): string[] {
    if (!html?.trim()) {
      return [];
    }
    const urls: string[] = [];
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('a[href]').forEach(el => {
      const href = el.getAttribute('href');
      if (href && !href.startsWith('mailto:') && !href.startsWith('#')) {
        urls.push(this.normalizeUrl(href));
      }
    });
    doc.querySelectorAll('img[src]').forEach(el => {
      const src = el.getAttribute('src');
      if (src) {
        urls.push(this.normalizeUrl(src));
      }
    });
    return urls;
  }
  private urlMatchesAttachment(editorUrl: string, attachmentUrl: string): boolean {
    const normalizedEditorUrl = this.normalizeUrl(editorUrl);
    const normalizedAttachmentUrl = this.normalizeUrl(attachmentUrl);
    return normalizedEditorUrl === normalizedAttachmentUrl
      || normalizedEditorUrl.includes(normalizedAttachmentUrl)
      || normalizedAttachmentUrl.includes(normalizedEditorUrl);
  }
  private syncAttachmentsFromEditor(html?: string): void {
    if (!this.embedsAttachmentsInEditor() || this.attachmentUploadsInProgress > 0) {
      return;
    }
    const messageHtml = html ?? this.EmailForm.get('message')?.value ?? '';
    const urlsInEditor = this.extractUrlsFromHtml(messageHtml);
    const nextImgUrl = this.imgUrl.filter(url =>
      urlsInEditor.some(editorUrl => this.urlMatchesAttachment(editorUrl, url))
    );
    if (nextImgUrl.length !== this.imgUrl.length) {
      this.imgUrl = nextImgUrl;
      this.refreshAttachmentView();
    }
  }
  private removeAttachmentFromMessage(url: string): void {
    let message = this.EmailForm.get('message')?.value || '';
    if (!message || !url) {
      return;
    }
    const escapedUrl = url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    message = message
      .replace(new RegExp(`<a[^>]*href=["']${escapedUrl}["'][^>]*>[\\s\\S]*?</a>\\s*(<br\\s*/?>)?`, 'gi'), '')
      .replace(new RegExp(`<img[^>]*src=["']${escapedUrl}["'][^>]*/?>\\s*(<br\\s*/?>)?`, 'gi'), '')
      .trim();
    this.updateEditorMessage(message);
  }
  get attachedFileCount(): number {
    return this.imgUrl?.length ?? 0;
  }
  private supportsAttachments(): boolean {
    return this.incidentW?.type == '1' || this.incidentW?.type == '2';
  }
  private embedsAttachmentsInEditor(): boolean {
    return this.incidentW?.type == '1' || this.incidentW?.type == '2';
  }
  private shouldRestrictFileTransferInEditor(): boolean {
    return this.incidentW?.type == '3';
  }
  private hasClipboardFilesOrImages(clipboardData: DataTransfer): boolean {
    if (this.getFilesFromDataTransfer(clipboardData).length) {
      return true;
    }
    if (clipboardData.items?.length) {
      for (let i = 0; i < clipboardData.items.length; i++) {
        if (clipboardData.items[i].type.startsWith('image/')) {
          return true;
        }
      }
    }
    return false;
  }
  private updateEditorMessage(html: string): void {
    this.EmailForm.patchValue({ message: html }, { emitEvent: false });
    if (this.activeFroalaEditor) {
      this.activeFroalaEditor.html.set(html);
    }
  }
  private toFileList(files: File[]): FileList {
    const dt = new DataTransfer();
    files.forEach(file => dt.items.add(file));
    return dt.files;
  }
  private getFileFingerprint(file: File): string {
    return `${file.name}|${file.size}|${file.lastModified}`;
  }
  private getFilesFromDataTransfer(dataTransfer: DataTransfer): File[] {
    const fileMap = new Map<string, File>();
    const addFile = (file: File | null) => {
      if (!file) {
        return;
      }
      const key = this.getFileFingerprint(file);
      if (!fileMap.has(key)) {
        fileMap.set(key, file);
      }
    };

    if (dataTransfer.files?.length) {
      for (let i = 0; i < dataTransfer.files.length; i++) {
        addFile(dataTransfer.files[i]);
      }
    }
    if (dataTransfer.items?.length) {
      for (let i = 0; i < dataTransfer.items.length; i++) {
        const item = dataTransfer.items[i];
        if (item.kind === 'file') {
          addFile(item.getAsFile());
        }
      }
    }
    return Array.from(fileMap.values());
  }
  private shouldSkipDuplicateTransfer(files: File[]): boolean {
    const signature = files.map(file => this.getFileFingerprint(file)).sort().join(';;');
    const now = Date.now();
    if (signature === this.lastFileTransferSignature && now - this.lastFileTransferAt < 600) {
      return true;
    }
    this.lastFileTransferSignature = signature;
    this.lastFileTransferAt = now;
    return false;
  }
  private isUrlAlreadyInMessage(url: string): boolean {
    const message = this.EmailForm.get('message')?.value || '';
    return this.extractUrlsFromHtml(message).some(editorUrl => this.urlMatchesAttachment(editorUrl, url));
  }
  private isUrlAlreadyAttached(url: string): boolean {
    return this.imgUrl.some(existing => this.urlMatchesAttachment(existing, url));
  }
  private buildAttachmentHtml(url: string): string {
    if (this.isImageUrl(url)) {
      return `<a href="${url}" target="_blank"><img src="${url}" alt="Image" class="img-fluid"/></a><br>`;
    }
    return `<a href="${url}" target="_blank">${this.getfileName(url)}</a><br>`;
  }
  private appendAttachmentsToMessage(urls: string[]): void {
    if (!urls.length || !this.embedsAttachmentsInEditor()) {
      return;
    }
    let concatenatedUrls = '';
    for (const url of urls) {
      if (this.isUrlAlreadyInMessage(url)) {
        continue;
      }
      concatenatedUrls += this.buildAttachmentHtml(url);
    }
    if (!concatenatedUrls) {
      return;
    }
    const currentMessage = this.EmailForm.get('message')?.value || '';
    const newMessage = currentMessage ? `${currentMessage}\n${concatenatedUrls}` : concatenatedUrls;
    this.updateEditorMessage(newMessage);
  }
  private attachClipboardOrDroppedFiles(dataTransfer: DataTransfer): boolean {
    if (!this.supportsAttachments()) {
      return false;
    }
    const files = this.getFilesFromDataTransfer(dataTransfer);
    if (!files.length) {
      return false;
    }
    if (this.shouldSkipDuplicateTransfer(files)) {
      return true;
    }
    this.handleFileInput(this.toFileList(files));
    return true;
  }
  ngOnInit() {
    const self = this;
    this.editorOptions = {
      key: 'sZH1rB3A5B6D5G4E4iAa1Tb1YZNYAh1CUKUEQOHFVANUqD1G1F4A3B1C8E7D2C4F3==',
      imagePaste: false,
      events: {
        'image.beforePasteUpload': function () {
          return false;
        },
        contentChanged: function () {
          self.syncAttachmentsFromEditor(this.html.get());
        },
        initialized: function () {
          const editor = this;
          self.activeFroalaEditor = editor;
          editor.events.on('drop', function (dropEvent) {
            const dt = dropEvent.originalEvent?.dataTransfer;
            if (!dt?.files?.length && !dt?.items?.length) {
              return;
            }
            if (self.shouldRestrictFileTransferInEditor() && self.getFilesFromDataTransfer(dt).length) {
              dropEvent.preventDefault();
              dropEvent.stopPropagation();
              return false;
            }
            if (self.attachClipboardOrDroppedFiles(dt)) {
              dropEvent.preventDefault();
              dropEvent.stopPropagation();
              return false;
            }
          }, true);
          editor.events.on('paste.before', function (pasteEvent) {
            const nativeEvent = pasteEvent.originalEvent || pasteEvent;
            const clipboardData = nativeEvent.clipboardData;
            if (!clipboardData) {
              return;
            }
            if (self.shouldRestrictFileTransferInEditor() && self.hasClipboardFilesOrImages(clipboardData)) {
              return false;
            }
            if (self.attachClipboardOrDroppedFiles(clipboardData)) {
              return false;
            }
          }, true);
        }
      }
    };
    this.maxlimitreached=false
    this.EmailForm = this.formBuilder.group({
      id:'',
      to:['',''],
      cc:['',''],
      subject:[''],
      message: ['']
    });

    this.EmailForm.get('message').valueChanges.subscribe((value) => {
      this.syncAttachmentsFromEditor(value || '');
    });

    this.standardUIService.castIncident.subscribe((val:any)=>{
      this.imgUrl=[];
      this.activeFroalaEditor = null;
      this.attachmentUploadsInProgress = 0;
      this.lastFileTransferSignature = '';
      this.lastFileTransferAt = 0;
      if(val){
        this.incidentW = val;
        if(this.incidentW.type == 1){
          if(this.incidentW.hasOwnProperty('item') && this.incidentW.item){
            //console.log(this.incidentW.item)
            this.disableSendButton = false;
            this.entrytype = this.incidentW.item.entrytype;
            this.EmailForm.patchValue({'message':this.incidentW.item.notes});
            this.EmailForm.patchValue({'id':this.incidentW.item.id});
          }else{
            //console.log(this.incidentW.item)
            this.entrytype = '';
            this.EmailForm.patchValue({'message':''});
            this.EmailForm.patchValue({'id':''});
            this.disableSendButton = true;
          }
        }
        else if(this.incidentW.type == 2){
          if(this.entityData.id > 0){
            this.emailNoteService.getContactByIncident(this.entityData.id).subscribe((result:any)=>{
              //console.log(result);
              //this.items = result;
              this.items = this.setTagInput(result);
              this.EmailForm.patchValue({'to':this.setTagInput(result)});
              if(this.incidentW.hasOwnProperty('item') && this.incidentW.item){
                //console.log(this.incidentW.item);
                this.disableSendButton = false;
                if(this.incidentW.item.inboundmessage)    {
                  this.items = this.incidentW.item.inboundmessage.to;
                  this.EmailForm.patchValue({'to':this.setTagInput(this.incidentW.item.inboundmessage.to)});
                  this.EmailForm.patchValue({'cc':this.setTagInput(this.incidentW.item.inboundmessage.cc)});
                  this.EmailForm.patchValue({'subject':this.incidentW.item.inboundmessage.subject});
                }
                this.EmailForm.patchValue({'message':this.incidentW.item.notes});
              } else{
                //this.EmailForm.patchValue({'to':this.setTagInput(this.incidentW.item.inboundmessage.to)});
                this.EmailForm.patchValue({'cc':''});
                this.EmailForm.patchValue({'subject':''});
                this.EmailForm.patchValue({'message':''});
                this.disableSendButton = true;
              }
            })
          }
        }
        else if(this.incidentW.type == 3){
          if(this.incidentW.hasOwnProperty('item') && this.incidentW.item){
            //console.log(this.incidentW.item)
            this.disableSendButton = false;
            this.entrytype = this.incidentW.item.entrytype;
            this.EmailForm.patchValue({'message':this.incidentW.item.notes});
            this.EmailForm.patchValue({'id':this.incidentW.item.id});
          }else{
            //console.log(this.incidentW.item)
            this.entrytype = '';
            this.EmailForm.patchValue({'message':''});
            this.EmailForm.patchValue({'id':''});
            this.disableSendButton = true;
          }
        }
      }
      //this.animationState = val === true ? 'in' : 'out';
    });
  }
  showPopover(popover: NgbPopover) {
    console.log("in popup")
    popover.open();
  }
  subject:any;

 // Define variables to store previous data
 previousKbsLink: number[] = [];
previousResult: any[] = [];

 stripHtml(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}

maxlimitreached:any;
  maximumtextswal() {
    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check">The maximum length of characters has been reached.</div></div>',
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',

    })
    this.deletemessage()
    this.maxlimitreached=true
  }

openDialog(): void {
  this.maxlimitreached=false
    const dialogRef = this.dialog.open(KnowledgebaseComponent, {
        width: '100%', // Set the width as per your requirement
        height:'90vh',

    });

    // Set the subject from the visible input
    this.kbs.subject = $(".pane:visible input[name='Incident.subject']").val();
this.kbs.incidentmessage="incident thread";
    // Example of what you can do with the dialog after it's closed
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result)
        result = this.kbs.message;
        console.log(this.kbs.subject)
        console.log(result) // Assuming this is intentional

        // Remove duplicates from previousKbsLink and previousResult
        this.previousKbsLink = [...new Set(this.previousKbsLink)];
        this.previousResult = this.previousResult.filter((item, index, self) =>

            index === self.findIndex((t) => t.id === item.id)

        );
        // Merge previous and present kbs.link and result
        const mergedKbsLink = [...this.previousKbsLink, ...this.kbs.link.filter(id => !this.previousKbsLink.includes(id))];
        const mergedResult = [...this.previousResult, ...result.filter(item => !this.previousResult.some(prevItem => prevItem.id === item.id))];

        console.log(mergedKbsLink);
        console.log(mergedKbsLink.length);
        console.log(mergedResult);
        console.log(this.kbs.customerportal)

        let message = '';

        if (mergedKbsLink.length === 0) {
            // If kbs.link is empty, append description and solution directly
            mergedResult.forEach((item: any) => {
                message += `${item.answeridobject.description}\n\n<br>${item.answeridobject.solution}\n\n<br>`;
            });
        } else {
            // Iterate through mergedResult
            mergedResult.forEach((item: any) => {
                // If item ID is in mergedKbsLink, append its description, solution, and link
                if (mergedKbsLink.includes(item.id)) {
                    message += `${item.answeridobject.description}\n\n${item.answeridobject.solution}\n\n<a href=${this.kbs.customerportal}${item.id}>${this.kbs.customerportal}${item.id}</a><br>`;
                } else {
                    // If item ID is not in mergedKbsLink, append only its description and solution
                    message += `${item.answeridobject.description}\n\n<br>${item.answeridobject.solution}\n\n<br>`;
                }
            });

            // Iterate through mergedKbsLink
            mergedKbsLink.forEach((linkId: number) => {
                // If linkId is not present in any mergedResult item ID, append it to message
                if (!mergedResult.some((item: any) => item.id === linkId)) {

                    message += `<a href=${this.kbs.customerportal}${linkId}>${this.kbs.customerportal}${linkId}</a><br>`;
                }
            });
        }

      if (message !== '') {
        console.log(message)
        if (message && message.length < 10000) {
          this.EmailForm.patchValue({
            'message': message,
          });
        }
        else {
          this.maximumtextswal();
          message=''
          this.kbs.message=[];
          this.kbs.link=[];
          this.EmailForm.patchValue({
            'message': '',
        });
          console.log("The maximum length of characters has been reached.");
        }

      } else {
          this.kbs.message=[];
          this.kbs.link=[];
          this.EmailForm.patchValue({
            'message': '',
        });
          console.log(message)
            console.log("No message to display");
            // Handle the case when no message is available
        }

        console.log('The dialog was closed');

      if (!this.maxlimitreached) {

        // Store the current data as previous for the next dialog open
        this.previousKbsLink = mergedKbsLink;
        this.previousResult = mergedResult;
      }

        // You can handle the result here if needed
    });
}
deletemessage(): void {
  // Clear previousKbsLink and previousResult arrays
  this.previousKbsLink = [];
  this.previousResult = [];
  this.kbs.link=[];
  this.kbs.message=[];
  this.imgUrl = [];
  this.attachmentUploadsInProgress = 0;
  this.lastFileTransferSignature = '';
  this.lastFileTransferAt = 0;
  if (this.fileInput?.nativeElement) {
    this.fileInput.nativeElement.value = '';
  }

  this.updateEditorMessage('');
  this.refreshAttachmentView();
  console.log('Data cleared:', this.previousKbsLink, this.previousResult);

  // Optionally, you can reset any form values or UI elements here
}





  entrytype;
  onSubmit(){
    $(".preview-submit").show();

    //console.log(this.EmailForm.value);
    let payload;
    if(this.incidentW.type == '1'){
      if(this.EmailForm.value.id){
        payload = {
          "id":this.EmailForm.value.id,
          "notes": this.EmailForm.value.message,
          "attachments": this.imgUrl,
          "threadentrytypeid":parseInt(this.incidentW.type),
          "entrytype":parseInt(this.entrytype)
        }
      }else{
        payload = {
          "notes": this.EmailForm.value.message,
          "attachments": this.imgUrl,
          "threadentrytypeid":parseInt(this.incidentW.type),
          "entrytype":parseInt(this.entrytype)
        }
      }
    }else if(this.incidentW.type == '2'){
      const to = [];
      for(var i = 0 ; i < this.EmailForm.value.to.length;i++){
        to.push(this.EmailForm.value.to[i].value);
      }
      const cc = [];
      for(var j = 0 ; j < this.EmailForm.value.cc.length;j++){
        cc.push(this.EmailForm.value.cc[j].value);
      }
      payload = {
        "inboundmessage":{
            "body_html": this.EmailForm.value.message,
            "to":to,
            "cc":cc,
            "subject":this.EmailForm.value.subject,
            "attachments": this.imgUrl,
        },
        "notes": this.EmailForm.value.message,
        "attachments": this.imgUrl,
        "threadentrytypeid":parseInt(this.incidentW.type)
      }
    }
    else if(this.incidentW.type == '3'){
      if(this.EmailForm.value.id){
        payload = {
          "id":this.EmailForm.value.id,
          "notes": this.EmailForm.value.message,
          "threadentrytypeid":parseInt(this.incidentW.type),
          "entrytype":parseInt(this.entrytype)
        }
      }else{
        payload = {
          "notes": this.EmailForm.value.message,
          "threadentrytypeid":parseInt(this.incidentW.type),
          "entrytype":parseInt(this.entrytype)
        }
      }
    }

    // console.log(payload);
    // return false;

    this.emailNoteService.onSaveEmailNote(this.entityData.entityName,this.entityData.id,payload).subscribe((result:any)=>{
      console.log(result);
      this.imgUrl = [];
      this.standardUIService.setIncidentEmailOrNote({"type":'',"open":false,item:'','saved':'true',enityId:this.entityData.id});
    })
  }

  d(){
    this.standardUIService.setIncidentEmailOrNote({"type":'',"open":false,item:''});
    // this.modalRef.close();
    $(".preview-submit").show();


  }
  setTagInput(result){
    this.items = [];
    for(var i = 0;i < result.length;i++){
      this.items.push({'display':result[i],'value':result[i]})
    }
    return this.items;
  }
  ngOnDestroy(){
    this.standardUIService.setIncidentEmailOrNote({"type":'',"open":false,item:''});
  }
  minimize(){
    $('.incident-window').addClass('window-minimize');
  }
  maximize(){
    $('.incident-window').removeClass('window-minimize');
  }


  errorforupload(file: any) {
    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>The below file exceeds the size limit. Please upload a file less than 10 MB.<br>If problem persists please contact support.</div></div>',
      html: file?.name || '',
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `OK`,
      cancelButtonText: 'Cancel'
    });
  }
  private showUploadError(file: File, error?: string) {
    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Unable to upload file.<br>Please try again or contact support if the problem persists.</div></div>',
      html: `${file?.name || 'File'}${error ? `<br><small>${error}</small>` : ''}`,
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: 'OK'
    });
  }
  handleFileInput(files: FileList) {
    if (!files?.length) {
      return;
    }

    const validFiles: File[] = [];
    const seenFiles = new Set<string>();
    for (let i = 0; i < files.length; i++) {
      const fingerprint = this.getFileFingerprint(files[i]);
      if (seenFiles.has(fingerprint)) {
        continue;
      }
      seenFiles.add(fingerprint);
      if (files[i].size > this.maxAttachmentSize) {
        this.errorforupload(files[i]);
      } else {
        validFiles.push(files[i]);
      }
    }

    if (!validFiles.length) {
      return;
    }

    const batchUrls: string[] = [];
    let completedUploads = 0;
    const batchSize = validFiles.length;
    this.attachmentUploadsInProgress += batchSize;

    validFiles.forEach((file) => {
      this.fileUploadService.upload(file).subscribe({
        next: (response) => {
          if (response && !this.isUrlAlreadyAttached(response)) {
            this.imgUrl.push(response);
            batchUrls.push(response);
          }
          completedUploads++;
          if (completedUploads === batchSize) {
            this.appendAttachmentsToMessage(batchUrls);
            this.attachmentUploadsInProgress -= batchSize;
            this.refreshAttachmentView();
          }
        },
        error: (error) => {
          completedUploads++;
          this.showUploadError(file, typeof error === 'string' ? error : '');
          if (completedUploads === batchSize) {
            this.appendAttachmentsToMessage(batchUrls);
            this.attachmentUploadsInProgress -= batchSize;
            this.refreshAttachmentView();
          }
        }
      });
    });
  }
  getfileName(imgUrl: string): string {
    if (!imgUrl) {
      return '';
    }

    const sectionsPart = imgUrl.split('sections/')[1];
    if (sectionsPart) {
      const arr = sectionsPart.split('_');
      arr.splice(0, 2);
      const parsedName = arr.join('_');
      if (parsedName) {
        return parsedName;
      }
    }

    const filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1);
    const lastUnderscorePos = filename.lastIndexOf('_');
    const secondLastUnderscorePos = filename.lastIndexOf('_', lastUnderscorePos - 1);

    if (secondLastUnderscorePos > -1) {
      const baseName = filename.substring(0, secondLastUnderscorePos);
      const extension = filename.split('.').pop();
      return extension ? `${baseName}.${extension}` : baseName;
    }

    return filename;
  }
  isImageUrl(url: string): boolean {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
  }
  randomId() {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + Date.now();
  }
  randomID = this.randomId();
  deleteUrl(index: number) {
    Swal.fire({

      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Are you sure?</div></div>',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      text: 'You want to permanently delete this file?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#275a8a',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
     console.log(result)
      if (result.value) {
        const removedUrl = this.imgUrl[index];
        this.imgUrl = this.imgUrl.filter((_, i) => i !== index);
        if (removedUrl) {
          this.removeAttachmentFromMessage(removedUrl);
        }
        if (this.fileInput?.nativeElement) {
          this.fileInput.nativeElement.value = '';
        }
        this.refreshAttachmentView();
        Swal.fire(
          '<div style="text-align:center;width: 100%;"> Deleted!</div>',
          'Your file has been deleted.',
          'success'
        )

      }
    })
  }
  }

